module.exports = __webpack_public_path__ + "img/4_2.1bc1faf0.jpg";